import { BrowserModule } from '@angular/platform-browser'
import { NgModule } from '@angular/core'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'
import { MDBBootstrapModule, ChartsModule } from 'angular-bootstrap-md'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LoginComponent } from './login/login.component'
import { HomeComponent } from './home/home.component'
import { GoalsComponent } from './goals/goals.component'
import { RegisterComponent } from './register/register.component'
import { NavbarComponent } from './navbar/navbar.component'
import { TransactionsComponent } from './transactions/transactions.component'
import { ViewTransactionsComponent } from './view-transactions/view-transactions.component'
import { JwtTokenInterceptor } from './interceptors/jwtToken.interceptor'
import { NoDataComponent } from './errors/no-data/no-data.component'
import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component'
import { NavigationBarComponent } from './intro/navigation-bar/navigation-bar.component'
import { FeaturesComponent } from '../app/features/features.component'
import { OpenAiComponent } from '../app/open-ai/open-ai.component'
import { AboutComponent } from '../app/about/about.component'
import { CurrencyConvertorComponent } from '../app/currency-convertor/currency-convertor.component'
import { CalculatorComponent } from '../app/calculator/calculator.component'
import { IntroComponent } from './intro/intro.component'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { InViewDirective } from '../app/directives/InViewDirective.directive'
import { CommonModule } from '@angular/common'
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency'


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    GoalsComponent,
    RegisterComponent,
    NavbarComponent,
    TransactionsComponent,
    ViewTransactionsComponent,
    NoDataComponent,
    PageNotFoundComponent,
    NavigationBarComponent,
    IntroComponent,
    FeaturesComponent,
    AboutComponent,
    CurrencyConvertorComponent,
    CalculatorComponent,
    InViewDirective,
    OpenAiComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    MDBBootstrapModule.forRoot(),
    ChartsModule,
    FormsModule,
    BrowserAnimationsModule,
    CommonModule,
    NgxCurrencyModule.forRoot({
      align: 'right',
      allowNegative: true,
      allowZero: true,
      decimal: '.',
      precision: 2,
      prefix: '',
      suffix: '',
      thousands: ',',
      nullable: true,
      min: null,
      max: null,
      inputMode: CurrencyMaskInputMode.FINANCIAL
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtTokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
